/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type PermissionResponsePagedResult,
    PermissionResponsePagedResultFromJSON,
    PermissionResponsePagedResultToJSON,
} from '../models/PermissionResponsePagedResult';
import {
    type PermissionSearchOrderBy,
    PermissionSearchOrderByFromJSON,
    PermissionSearchOrderByToJSON,
} from '../models/PermissionSearchOrderBy';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiPermissionsGetRequest {
    applicationId?: string;
    textFilter?: string;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: PermissionSearchOrderBy;
}

/**
 * 
 */
export class PermissionsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiPermissionsGet without sending the request
     */
    async apiPermissionsGetRequestOpts(requestParameters: ApiPermissionsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['applicationId'] != null) {
            queryParameters['ApplicationId'] = requestParameters['applicationId'];
        }

        if (requestParameters['textFilter'] != null) {
            queryParameters['TextFilter'] = requestParameters['textFilter'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/permissions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiPermissionsGetRaw(requestParameters: ApiPermissionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionResponsePagedResult>> {
        const requestOptions = await this.apiPermissionsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiPermissionsGet(requestParameters: ApiPermissionsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionResponsePagedResult> {
        const response = await this.apiPermissionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
